import { mensajeSimple, modalCargando } from "./ui/sweetAlerts";
import { getExcel } from "../api/apis";

export const BtnEnviarGenerarExcel = ({
  ubicacionArchivo,
  agregarFecha = false,
}) => {
  const generarExcel = async () => {
    console.clear();
    modalCargando("Descargando archivo Excel");
    const separador = ubicacionArchivo.includes("?") ? "&" : "?";
    // El timestamp solo para evitar cache, no afecta el nombre del archivo
    const urlDescarga = `${ubicacionArchivo}${separador}_=${new Date().getTime()}`;

    try {
      const response = await getExcel(urlDescarga);

      if (typeof response === "number") {
        if (response === 404) {
          mensajeSimple("error", "Archivo no encontrado.", 3000);
        } else {
          mensajeSimple("error", `Error al descargar el archivo (código: ${response})`, 3000);
        }
        return;
      }

      const nombreOriginal = ubicacionArchivo.split("/").pop();
      let nombreArchivo = nombreOriginal;
      if (agregarFecha) {
        const fecha = new Date();
        const yyyy = fecha.getFullYear();
        const mm = String(fecha.getMonth() + 1).padStart(2, "0");
        const dd = String(fecha.getDate()).padStart(2, "0");
        const fechaStr = `${yyyy}-${mm}-${dd}`;
        // Insertar fecha antes de la extensión, con formato nombre_yyyy-mm-dd.xlsx
        const match = nombreOriginal.match(/^(.*?)(\.[^.]*)?$/);
        if (match) {
          const base = match[1];
          // Forzar extensión .xlsx
          nombreArchivo = `${base}_${fechaStr}.xlsx`;
        } else {
          nombreArchivo = `${nombreOriginal}_${fechaStr}.xlsx`;
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nombreArchivo);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      mensajeSimple("success", "Descarga completada.", 1500);
    } catch (error) {
      mensajeSimple(
        "error",
        error?.response?.status === 404
          ? "Archivo no encontrado."
          : "Ocurrió un problema al intentar descargar el archivo Excel.",
        3000
      );
    }
  };
  return (
    <button className="btnExcel" onClick={generarExcel}>
      Descargar Excel
    </button>
  );
};